
import { useState } from "react";
import { NewsArticle } from "../types";
import { toast } from "@/components/ui/use-toast";

interface UseArticleCreationProps {
  articles: NewsArticle[];
  setArticles: React.Dispatch<React.SetStateAction<NewsArticle[]>>;
}

export const useArticleCreation = ({ articles, setArticles }: UseArticleCreationProps) => {
  const [newArticle, setNewArticle] = useState<Omit<NewsArticle, "id">>({
    title: "",
    description: "",
    content: "",
    date: new Date().toLocaleDateString("el-GR"),
    category: "news",
    image: null,
    isPublic: true
  });

  const handleAddArticle = () => {
    if (!newArticle.title || !newArticle.description) {
      toast({
        title: "Σφάλμα",
        description: "Παρακαλώ συμπληρώστε τον τίτλο και την περιγραφή",
        variant: "destructive"
      });
      return;
    }

    const newId = Math.max(...articles.map(a => a.id), 0) + 1;
    
    const articleToAdd: NewsArticle = {
      id: newId,
      ...newArticle
    };
    
    setArticles([...articles, articleToAdd]);
    
    toast({
      title: "Επιτυχία",
      description: "Το άρθρο προστέθηκε επιτυχώς"
    });
    
    // Reset form
    setNewArticle({
      title: "",
      description: "",
      content: "",
      date: new Date().toLocaleDateString("el-GR"),
      category: newArticle.category,
      image: null,
      isPublic: true
    });
  };

  return { newArticle, setNewArticle, handleAddArticle };
};
